import React, { useState, useEffect } from 'react';
import {REGIONS_EXCEPTION} from './constant';

export function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = () => setMatches(media.matches);
        window.addEventListener('resize', listener);
        return () => window.removeEventListener('resize', listener);
    }, [matches, query]);
    return matches;
}

export function getEventNameLocale(event, locale) {
    if ((locale in event.name) && (event.name[locale])) {
        return event.name[locale];
    } else if (('en' in event.name) && (event.name.en)) {
        return event.name.en;
    } else {
        const keyWithValue = Object.keys(event.name).find((key) => event.name[key] !== null);
        if (event.name[keyWithValue]) {
            return event.name[keyWithValue]
        } else {
            return;
        }
    }
}

export function useToggle(initialValue = false) {
    const [value, setValue] = useState(initialValue);

    const toggle = React.useCallback(() => {
        setValue(v => !v);
    }, []);

    return [value, toggle];
}

export function getRegionWithException(venue) {
    let regionException = REGIONS_EXCEPTION.find(exceptArray => exceptArray.country_code === venue.country_code);

    if (regionException !== undefined) {
        return regionException.country_name;
    }

    return venue.region;
}
